<template>
  <span v-if="message" :key="showKey">

    <span v-if="showComponent">
      <span @click="showBtn">
        <slot></slot>
      </span>

      <AddSefosMessage
        v-if="message.message_type != 'sdk-message' && message.message_type != 'fax-message'"
        :show="show"
        :reply_loa="reply_loa"
        :reply_attachments="reply_attachments"
        :reply_subject="reply_subject"
        :reply_body="reply_body"
        :reply_emails="reply_emails"
        :reply_message_uuid="reply_message_uuid"
        :user_uuid="user_uuid"
        :functionbox_uuid="functionbox_uuid"
        @changeShow="changeShow"
        @sentMessage="sentMessage"
      ></AddSefosMessage>

      <AddSDKMessage
        v-if="message.message_type == 'sdk-message'"
        :show="show"
        :reply_loa="reply_loa"
        :reply_subject="reply_subject"
        :reply_body="reply_body"
        :reply-complete="replyComplete"
        :reply_identifier="reply_identifier"
        :reply_organisation="reply_organisation"
        :reply_message_uuid="reply_message_uuid"
        :reply_metadata="reply_metadata"
        :functionbox_uuid="functionbox_uuid"
        @changeShow="changeShow"
        @sentMessage="sentMessage"
      ></AddSDKMessage>

      <AddFaxMessage
        v-if="message.message_type == 'fax-message'"
        :show="show"
        :reply_attachments="reply_attachments"
        :reply_identifier="reply_identifier"
        :functionbox_uuid="functionbox_uuid"
        :reply_metadata="reply_metadata"
        @changeShow="changeShow"
        @sentMessage="sentMessage"
      ></AddFaxMessage>
    </span>
  </span>
</template>
<script>
import AddSefosMessage from "@/components/Compose/Message/SefosMessage";
import AddSDKMessage from "@/components/Compose/Message/SDKMessage";
import AddFaxMessage from "@/components/Compose/Message/FaxMessage";
export default {
  props: {
    replyAll: {
      type: Boolean,
      validator(value) {
        return value != undefined;
      },
    },
    replyComplete: {
      type: Boolean,
      validator(value) {
        return value != undefined;
      },
    },
    functionbox_uuid: {
      default: "",
      type: String,
    },
    message: {
      default: null,
      type: Object,
    },
    user_uuid: {
      default: "",
      type: String,
    },
    external_system_participants: {
      default: null,
      type: Array,
    }
  },
  components: {
    AddSefosMessage,
    AddSDKMessage,
    AddFaxMessage
  },
  data() {
    return {
      showIndex: 0,
      showComponent: true,
      reply_identifier: "",
      reply_organisation: "",
      reply_message_uuid: "",
      reply_subject: "",
      reply_body: "",
      reply_emails: [],
      reply_loa: 3,
      reply_metadata: null,
      reply_attachments: [],
      show: false
    };
  },
  methods: {
    showBtn() {
      this.show = true;
    },
    changeShow(val) {
      this.show = val;
      this.showIndex++;
    },
    sentMessage() {
      this.showIndex++;
      this.show = false;
      this.$emit("sentMessage");
    },
    getEmails(recipients) {
      let emails = "";
      for (let ix = 0; ix < recipients.length; ix++) {
        let item = this.message.recipients[ix];
        if (item.email != this.currentEmail) {
          if (item.type == "SEFOS" || item.type == "LINK") {
            if (emails == "") {
              emails = item.email;
            } else {
              emails = ", " + item.email;
            }
          }
        }
      }
      return emails;
    },
    buildReplyContent() {
      let to = this.getEmails(this.message.recipients);
      let sent = this.FormatDateTime(this.message.created_date);
      let content =
        "From: " +
        this.message.creator.name +
        " - " +
        this.message.creator.email;
      content = content + "\nSent: " + sent;
      content = content + "\nTo: " + to;
      content = content + "\nSubject: " + this.message.subject;
      content = content + "\n\n" + this.message.body;
      return content;
    },
  },
  computed: {
    showKey(){
      return "showKey" + this.showIndex;
    },
    currentEmail() {
      let self = this;
      let currentEmail = this.user.information.email;
      if (this.functionbox_uuid != "") {
        let me = this.user.functionboxes.items.filter(
          (c) => c.functionbox_uuid == self.functionbox_uuid
        );
        if (me.length != 0) {
          currentEmail = me[0].email;
        }
      } else {
        if (this.user_uuid != "") {
          let me = this.user.delegatedboxes.items.filter(
            (c) => c.user_uuid == self.user_uuid
          );
          if (me.length != 0) {
            currentEmail = me[0].email;
          }
        }
      }
      return currentEmail;
    },
    currentSignature() {
      let self = this;
      let currentSignature = this.user.information.signature;
      if (this.functionbox_uuid != "") {
        let me = this.user.functionboxes.items.filter(
          (c) => c.functionbox_uuid == self.functionbox_uuid
        );
        if (me.length != 0) {
          currentSignature = me[0].signature;
        }
      } else {
        if (this.user_uuid != "") {
          let me = this.user.delegatedboxes.items.filter(
            (c) => c.user_uuid == self.user_uuid
          );
          if (me.length != 0) {
            currentSignature = me[0].signature;
          }
        }
      }
      return currentSignature;
    },
  },
  mounted() {
    this.reply_loa = this.message.settings.loa_level;
    if (this.message.response_to_message == "") {
      this.reply_subject =
        this.$t("RESPONSE_START") + " " + this.message.subject;
    } else {
      this.reply_subject = this.message.subject;
    }
    if (this.currentSignature != "") {
      this.reply_body =
        "\n\n----------------------------\n" +
        this.currentSignature +
        "\n\n---------------------------------------------------------\n" +
        this.buildReplyContent();
    } else {
      this.reply_body =
        "\n\n---------------------------------------------------------\n" +
        this.buildReplyContent();
    }
    this.reply_message_uuid = this.message.message_uuid;
    if (this.message.message_type == "sdk-message") {
      if (this.replyAll) {
        this.showComponent = false;
      } else {
        if (this.replyComplete) {
          let SdkRecipient = this.external_system_participants[0];
          this.reply_metadata = SdkRecipient.metadata;
          this.reply_identifier = SdkRecipient.metadata.ToParticipantFunctionId;
          this.reply_organisation = SdkRecipient.metadata.ToParticipantOrganisationId;
        }else{
          if(this.message.creator.external_system != undefined)
          {
            this.reply_metadata = this.message.creator.external_system.metadata;
            this.reply_identifier = this.message.creator.external_system.metadata.FromParticipantFunctionId;
            this.reply_organisation = this.message.creator.external_system.metadata.ToParticipantOrganisationId;
          }
        }
      }
    } else if (this.message.message_type == "fax-message") {
      this.reply_attachments = this.message.attachments;
      if (this.replyAll) {
        this.showComponent = false;
      } else {
        if(this.message.creator.external_system != null)
        {
          this.reply_identifier = this.message.creator.external_system.metadata.FromFaxNumber.replace("00", "+");          
        }else{
          this.reply_identifier = "";
        }
      }
    } else{
      if(this.message.message_type == 'link-response')
      {
        if (this.replyAll || (this.replyComplete)) {
          this.showComponent = false;
        }
        this.reply_emails.push(this.message.creator.email);
      }else{
        if ( (this.replyAll) || (this.replyComplete)) {
          for (let ix = 0; ix < this.message.recipients.length; ix++) {
            let item = this.message.recipients[ix];
            if (item.email != this.currentEmail) {
              if (item.type == "SEFOS" || item.type == "LINK") {
                this.reply_emails.push(item.email);
              }
            }
          }        
          if(this.replyAll)
          {
            this.reply_emails.push(this.message.creator.email);
          }
        } else {
          this.reply_emails.push(this.message.creator.email);
        }
      }
    }
  },
};
</script>